import { set } from 'lodash';
import React from 'react';
import { Modal } from 'react-bootstrap';

const GlobalModal = ({ visible, countdown, children }) => {
  if (!visible) return null;
  return (
    <Modal show={visible} centered>
      <div
        style={{
          background: '#e3f2fd',
          color: '#66717eff',
          padding: '20px 0',
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          fontWeight: 'bold',
          fontSize: '22px',
          width: '100%',
          textAlign: 'center',
        }}
      >
        Cierre de sesión
      </div>
      <Modal.Body>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            margin: '32px 0 8px 0',
          }}
        >
          <span style={{ fontSize: '28px', marginRight: '12px' }}>🚨</span>
          <span>Cerrando sesión por mantenimiento...</span>
          <span style={{ fontSize: '28px', marginLeft: '12px' }}>🚨</span>
        </div>
        <p style={{ fontSize: '16px', color: '#555', textAlign: 'center' }}>
          Redirigiendo en <strong>{countdown}</strong> segundos...
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default GlobalModal;
